// src/walletBlock.js
// 🚫 Permanently disable MetaMask / wallet connect attempts across the app

(function walletBlock() {
  if (typeof window === 'undefined') return;

  const BLOCK_ERR = new Error('Wallet connections are disabled');

  function blockProvider(eth) {
    if (!eth || eth.__walletBlocked) return;

    try {
      // Replace request/enable with rejections
      const rejector = (..._args) => Promise.reject(BLOCK_ERR);

      eth.request = rejector;
      eth.enable = rejector;
      eth.on = eth.addListener = () => {};

      eth.__walletBlocked = true;
      // Optional: remove this if you don't want any console noise
      console.log('[WalletBlock] Ethereum wallet interface disabled');
    } catch {
      // Fallback: redefine window.ethereum if it's read-only
      Object.defineProperty(window, 'ethereum', {
        configurable: false,
        enumerable: false,
        get: () => ({
          isMetaMask: false,
          request: () => Promise.reject(BLOCK_ERR),
          enable: () => Promise.reject(BLOCK_ERR),
        }),
      });
    }
  }

  // 1) Block immediately
  blockProvider(window.ethereum);

  // 2) Re-block periodically (some extensions re-inject)
  const interval = setInterval(() => {
    try { blockProvider(window.ethereum); } catch {}
  }, 500);

  // 3) Stop checking when page unloads
  window.addEventListener('beforeunload', () => clearInterval(interval));
})();
